import StoreConfirmationPage from './StoreConfirmationPage';

export default StoreConfirmationPage;
